// extracted by mini-css-extract-plugin
module.exports = {"paymentMethods":"PaymentMethods-module__paymentMethods____aCzg","secure":"PaymentMethods-module__secure___3oDJm","providers":"PaymentMethods-module__providers___lOgDm"};